export const contactsData = {
    email: 'vishnughosh.usa@gmail.com',
    phone: '',
    address: 'Buffalo, New York',

    sheetAPI: ''
}